import { createFileRoute } from '@tanstack/react-router'

// Bare /teams (no team selected): TeamsLayout renders the full-width rail with its SlideInPanel closed,
// so this index match renders nothing into the (collapsed) detail Outlet. Selecting a team navigates to
// `/teams/$teamId/report`.
export const Route = createFileRoute('/_app/teams/')({
  component: () => null,
})
